import EphemeralId from './EphemeralId';

export default EphemeralId;
